function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.85 18.675c-.375 0-.725-.05-1.05-.2v3.475c0 .4.325.725.725.725h2.7c.4 0 .725-.325.725-.725v-5.125l-.95.95c-.6.6-1.375.9-2.15.9zM8.45 13.325l-1.55 1.55v7.075c0 .4.325.725.725.725H10.3c.425 0 .75-.325.75-.725V15.9c-.05-.025-.075-.075-.125-.125l-2.475-2.45zM12.975 16.7v5.25c0 .4.325.725.725.725h2.675a.71.71 0 00.725-.725v-8.075L15.175 15.8c-.6.6-1.4.9-2.2.9zM20.7 10.3l-1.65 1.65v10c0 .4.325.725.75.725h2.7c.4 0 .725-.325.725-.725v-11.1c-.225.05-.45.075-.675.075a2.768 2.768 0 01-1.85-.625z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.05 2.65c-.25-.25-.6-.375-.95-.3l-4.6.725c-.4.075-.75.35-.875.75s-.025.825.275 1.125l1.075 1.075-5.925 5.9-3.75-3.75a1.222 1.222 0 00-1.725 0l-6.6 6.6a1.222 1.222 0 000 1.725c.225.225.55.35.85.35.3 0 .625-.125.85-.35l5.75-5.75 3.75 3.75c.475.475 1.25.475 1.725 0l6.775-6.775L21.75 8.8c.2.2.5.325.775.325.125 0 .225-.025.35-.05.4-.125.7-.475.75-.875l.725-4.575a1.063 1.063 0 00-.3-.975z"
}));

var SvgReports = function SvgReports(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReports, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reports.340a071a.svg";
export { ForwardRef as ReactComponent };